export default "<app-pharmacy-list></app-pharmacy-list>\r\n";